// extracted by mini-css-extract-plugin
export var preamble = "PageInvestmentFund-module--preamble--yQNdH";